import { DeleteOutlined } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'
import styled from 'styled-components'

const RemoveBtn = (props) => {
  let {
    loading = false, disabled = false,
    onClick, title = 'Remove'
  } = props

  let content
  let click
  if (loading === false) {
    content = <DeleteOutlined />
    click = onClick
  }
  return (
    <Page>
      <Tooltip placement="top" title={title}>
        <Button
          shape="circle" disabled={disabled}
          loading={loading} onClick={click}>
          {content}
        </Button>
      </Tooltip>
    </Page>
  )
}

const Page = styled.div`
  button {
    color: #3F3F3F;
    background-color: #ffaaa6;

    height: 45px
    width: 45px;
  }

  button > i {
    font-size: 16px;
  }

  button:hover {
    color: #ffaaa6;
    background-color: white;
    border-color: #ffaaa6;
  }
`

export default RemoveBtn
